const featureFlags = {
	FLATTENING: "flattening",
	DISCUSSION: "discussion",
	PRODUCTIONS_BETA: "productions_beta",
};

export default featureFlags;
